var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-field',{staticClass:"mt-4"},[_c('b-button',{attrs:{"type":"is-danger","loading":_vm.loading,"disabled":_vm.loading},on:{"click":_vm.submit}},[_vm._v("\n      Supprimer la sélection\n    ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }